// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AppIcon-base__k16rc{display:block;align-self:center;width:var(--size-10);height:var(--size-10);border-radius:var(--border-radius-2);box-shadow:var(--box-shadow-md-down-contrast)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AppIcon-base__k16rc"
};
export default ___CSS_LOADER_EXPORT___;
